import { Notify, Loading, Report, Confirm } from 'notiflix'

// กำหนดค่าเริ่มต้นสำหรับ Notiflix
export const initializeNotiflix = () => {
  // ตั้งค่า Notify
  Notify.init({
    width: '320px',
    position: 'right-top',
    distance: '10px',
    opacity: 1,
    borderRadius: '8px',
    rtl: false,
    timeout: 3000,
    messageMaxLength: 110,
    backOverlay: false,
    backOverlayColor: 'rgba(0,0,0,0.5)',
    plainText: true,
    showOnlyTheLastOne: false,
    clickToClose: false,
    pauseOnHover: true,
    ID: 'NotiflixNotify',
    className: 'notiflix-notify',
    zindex: 4001,
    fontFamily: 'Quicksand',
    fontSize: '13px',
    cssAnimation: true,
    cssAnimationDuration: 400,
    cssAnimationStyle: 'fade',
    closeButton: false,
    useIcon: true,
    useFontAwesome: false, // ปิดการใช้ Font Awesome
    fontAwesomeIconStyle: 'basic',
    fontAwesomeIconSize: '16px',
    success: {
      background: '#32d296',
      textColor: '#fff',
      childClassName: 'notiflix-notify-success',
      notiflixIconColor: 'rgba(0,0,0,0.2)',
      fontAwesomeClassName: '', // ไม่ใช้ Font Awesome
      fontAwesomeIconColor: 'rgba(0,0,0,0.2)',
      backOverlayColor: 'rgba(50,210,150,0.2)',
    },
    failure: {
      background: '#ff5549',
      textColor: '#fff',
      childClassName: 'notiflix-notify-failure',
      notiflixIconColor: 'rgba(0,0,0,0.2)',
      fontAwesomeClassName: '', // ไม่ใช้ Font Awesome
      fontAwesomeIconColor: 'rgba(0,0,0,0.2)',
      backOverlayColor: 'rgba(255,85,73,0.2)',
    },
    warning: {
      background: '#eebf31',
      textColor: '#fff',
      childClassName: 'notiflix-notify-warning',
      notiflixIconColor: 'rgba(0,0,0,0.2)',
      fontAwesomeClassName: '', // ไม่ใช้ Font Awesome
      fontAwesomeIconColor: 'rgba(0,0,0,0.2)',
      backOverlayColor: 'rgba(238,191,49,0.2)',
    },
    info: {
      background: '#26c0d3',
      textColor: '#fff',
      childClassName: 'notiflix-notify-info',
      notiflixIconColor: 'rgba(0,0,0,0.2)',
      fontAwesomeClassName: '', // ไม่ใช้ Font Awesome
      fontAwesomeIconColor: 'rgba(0,0,0,0.2)',
      backOverlayColor: 'rgba(38,192,211,0.2)',
    },
  })

  // ตั้งค่า Loading
  Loading.init({
    className: 'notiflix-loading',
    zindex: 4000,
    backgroundColor: 'rgba(0,0,0,0.8)',
    rtl: false,
    fontFamily: 'Quicksand',
    cssAnimation: true,
    cssAnimationDuration: 400,
    clickToClose: false,
    customSvgUrl: null,
    customSvgCode: null,
    svgSize: '80px',
    svgColor: '#32d296',
    messageID: 'NotiflixLoadingMessage',
    messageFontSize: '15px',
    messageMaxLength: 34,
    messageColor: '#ddd',
  })

  // ตั้งค่า Report
  Report.init({
    className: 'notiflix-report',
    width: '320px',
    backgroundColor: '#f8f8f8',
    borderRadius: '25px',
    rtl: false,
    zindex: 4002,
    backOverlay: true,
    backOverlayColor: 'rgba(0,0,0,0.5)',
    backOverlayClickToClose: false,
    fontFamily: 'Quicksand',
    svgSize: '110px',
    plainText: true,
    titleFontSize: '16px',
    titleMaxLength: 34,
    messageFontSize: '13px',
    messageMaxLength: 400,
    buttonFontSize: '14px',
    buttonMaxLength: 34,
    cssAnimation: true,
    cssAnimationDuration: 360,
    cssAnimationStyle: 'fade',
  })

  // ตั้งค่า Confirm
  Confirm.init({
    className: 'notiflix-confirm',
    width: '300px',
    zindex: 4003,
    position: 'center',
    distance: '10px',
    backgroundColor: '#f8f8f8',
    borderRadius: '25px',
    backOverlay: true,
    backOverlayColor: 'rgba(0,0,0,0.5)',
    rtl: false,
    fontFamily: 'Quicksand',
    cssAnimation: true,
    cssAnimationStyle: 'fade',
    cssAnimationDuration: 300,
    plainText: true,
    titleColor: '#32c682',
    titleFontSize: '16px',
    titleMaxLength: 34,
    messageColor: '#1e1e1e',
    messageFontSize: '14px',
    messageMaxLength: 110,
    buttonsFontSize: '15px',
    buttonsMaxLength: 34,
    okButtonColor: '#f8f8f8',
    okButtonBackground: '#32c682',
    cancelButtonColor: '#f8f8f8',
    cancelButtonBackground: '#a9a9a9',
  })
}

// Notification utilities
export const showSuccess = (message: string, timeout?: number) => {
  Notify.success(message, { timeout: timeout || 3000 })
}

export const showError = (message: string, timeout?: number) => {
  Notify.failure(message, { timeout: timeout || 5000 })
}

export const showWarning = (message: string, timeout?: number) => {
  Notify.warning(message, { timeout: timeout || 4000 })
}

export const showInfo = (message: string, timeout?: number) => {
  Notify.info(message, { timeout: timeout || 3000 })
}

// Loading utilities
export const showLoading = (message?: string) => {
  Loading.standard(message || 'กำลังโหลด...')
}

export const showLoadingWithMessage = (message: string) => {
  Loading.standard(message)
}

export const hideLoading = () => {
  Loading.remove()
}

// Report utilities
export const showSuccessReport = (title: string, message: string, buttonText?: string) => {
  Report.success(title, message, buttonText || 'ตกลง')
}

export const showErrorReport = (title: string, message: string, buttonText?: string) => {
  Report.failure(title, message, buttonText || 'ตกลง')
}

export const showWarningReport = (title: string, message: string, buttonText?: string) => {
  Report.warning(title, message, buttonText || 'ตกลง')
}

export const showInfoReport = (title: string, message: string, buttonText?: string) => {
  Report.info(title, message, buttonText || 'ตกลง')
}

// Confirm utilities
export const showConfirm = (
  title: string,
  message: string,
  okButtonText?: string,
  cancelButtonText?: string
): Promise<boolean> => {
  return new Promise((resolve) => {
    Confirm.show(
      title,
      message,
      okButtonText || 'ยืนยัน',
      cancelButtonText || 'ยกเลิก',
      () => resolve(true),
      () => resolve(false)
    )
  })
}

export const showDeleteConfirm = (itemName: string): Promise<boolean> => {
  return showConfirm(
    'ยืนยันการลบ',
    `คุณต้องการลบ "${itemName}" หรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้`,
    'ลบ',
    'ยกเลิก'
  )
}

export default {
  initializeNotiflix,
  showSuccess,
  showError,
  showWarning,
  showInfo,
  showLoading,
  showLoadingWithMessage,
  hideLoading,
  showSuccessReport,
  showErrorReport,
  showWarningReport,
  showInfoReport,
  showConfirm,
  showDeleteConfirm
}